import { FEATURE_IDS_MAP, MODULE_IDS_MAP } from './constants'

export const ROLES_MAP = {
  admin: {
    key: 'Admin',
    roleId: '',
    title: 'Admin',
  },
  group_admin: {
    key: 'GroupAdmin',
    roleId: '',
    title: 'GroupAdmin',
  },
  super_admin: {
    key: 'SuperAdmin',
    roleId: '',
    title: 'SuperAdmin',
  },
  central: {
    key: 'Central',
    roleId: '',
    title: 'Central',
  },
  central_1: {
    key: 'X-Central',
    roleId: '',
    title: 'X-Central',
  },
  DME: {
    key: 'DME',
    roleId: '',
    title: 'DME',
  },
  DME_1: {
    key: 'X-DME',
    roleId: '',
    title: 'X-DME',
  },
  CME: {
    key: 'CME',
    roleId: '',
    title: 'CME',
  },
  RCME: {
    key: 'R-CME',
    roleId: '',
    title: 'R-CME',
  },
  CSM_SUPERVISOR: {
    key: 'CSM_SUPERVISOR',
    roleId: '',
    title: 'CSM_SUPERVISOR',
  },
  ENGINEERING_SUPERVISOR: {
    key: 'ENGINEERING_SUPERVISOR',
    roleId: '',
    title: 'ENGINEERING_SUPERVISOR',
  },
  GIS_SUPERVISOR: {
    key: 'GIS_SUPERVISOR',
    roleId: '',
    title: 'GIS_SUPERVISOR',
  },
  ECOLOGY_SUPERVISOR: {
    key: 'ECOLOGY_SUPERVISOR',
    roleId: '',
    title: 'ECOLOGY_SUPERVISOR',
  },
  DS_SUPERVISOR: {
    key: 'DS_SUPERVISOR',
    roleId: '',
    title: 'DS_SUPERVISOR',
  },
  INGESTION_PROCESSOR: {
    key: 'INGESTION_PROCESSOR',
    roleId: '',
    title: 'INGESTION_PROCESSOR',
  },
}

export const permissions = {
  [ROLES_MAP.group_admin.key]: {
    [FEATURE_IDS_MAP.siteListTabs1]: 1,
    [FEATURE_IDS_MAP.siteListTabs2]: -1,
    [FEATURE_IDS_MAP.createBNGPlan]: 1,
    [FEATURE_IDS_MAP.exportShapefile]: 1,
    [FEATURE_IDS_MAP.dsAutomation]: 1,
    [FEATURE_IDS_MAP.bulkCreation]: 1,
  },
  [ROLES_MAP.super_admin.key]: {
    [FEATURE_IDS_MAP.siteListTabs1]: -1,
    [FEATURE_IDS_MAP.siteListTabs2]: 1,
    [FEATURE_IDS_MAP.createBNGPlan]: 1,
    [FEATURE_IDS_MAP.exportShapefile]: 1,
    [FEATURE_IDS_MAP.dsAutomation]: 1,
    [FEATURE_IDS_MAP.bulkCreation]: 1,
  },
  [ROLES_MAP.CSM_SUPERVISOR.key]: {
    [MODULE_IDS_MAP.aoiModule]: 1,
    [FEATURE_IDS_MAP.createBNGPlan]: 1,
    [FEATURE_IDS_MAP.exportShapefile]: 1,
    [FEATURE_IDS_MAP.dsAutomation]: 1,
    [FEATURE_IDS_MAP.bulkCreation]: 1,
  },
  [ROLES_MAP.GIS_SUPERVISOR.key]: {
    [MODULE_IDS_MAP.aoiModule]: -1,
    [FEATURE_IDS_MAP.createBNGPlan]: 1,
    [FEATURE_IDS_MAP.exportShapefile]: 1,
    [FEATURE_IDS_MAP.dsAutomation]: 1,
    [FEATURE_IDS_MAP.bulkCreation]: 1,
  },
  [ROLES_MAP.ECOLOGY_SUPERVISOR.key]: {
    [MODULE_IDS_MAP.aoiModule]: -1,
    [FEATURE_IDS_MAP.createBNGPlan]: 1,
    [FEATURE_IDS_MAP.exportShapefile]: 1,
    [FEATURE_IDS_MAP.dsAutomation]: 1,
    [FEATURE_IDS_MAP.bulkCreation]: 1,
  },
  [ROLES_MAP.ENGINEERING_SUPERVISOR.key]: {
    [MODULE_IDS_MAP.aoiModule]: 1,
    [FEATURE_IDS_MAP.createBNGPlan]: 1,
    [FEATURE_IDS_MAP.exportShapefile]: 1,
    [FEATURE_IDS_MAP.dsAutomation]: 1,
    [FEATURE_IDS_MAP.bulkCreation]: 1,
  },
  [ROLES_MAP.DS_SUPERVISOR.key]: {
    [MODULE_IDS_MAP.aoiModule]: -1,
    [FEATURE_IDS_MAP.createBNGPlan]: 1,
    [FEATURE_IDS_MAP.exportShapefile]: 1,
    [FEATURE_IDS_MAP.dsAutomation]: 1,
    [FEATURE_IDS_MAP.bulkCreation]: 1,
  },
  [ROLES_MAP.INGESTION_PROCESSOR.key]: {
    [MODULE_IDS_MAP.aoiModule]: 1,
    [FEATURE_IDS_MAP.createBNGPlan]: 1,
    [FEATURE_IDS_MAP.exportShapefile]: 1,
    [FEATURE_IDS_MAP.dsAutomation]: 1,
    [FEATURE_IDS_MAP.bulkCreation]: 1,
  },
}
